/**
 * Mobile menu
 */
const component_pages_menu = () => {

  const buttons = document.querySelectorAll('.js-pages-toggle');
  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', (e) => {
      const li = e.currentTarget.parentNode.parentNode;
      if (li.classList.contains('is-open')) {
        li.classList.add('is-closing');
        setTimeout((li) => {
          li.classList.remove('is-closing');
          li.classList.remove('is-open');
        }, 250, li);
      } else {
        li.classList.add('is-open');
      }
    });
  }

  const menuToggles = document.querySelectorAll('.js-menu-toggle');
  for (let i = 0; i < menuToggles.length; i++) {
    menuToggles[i].addEventListener('click', (e) => {
      document.body.classList.remove('is-open-search');
      document.body.classList.toggle('is-open-menu');
    });
  }

  const searchToggles = document.querySelectorAll('.js-search-toggle');
  for (let i = 0; i < searchToggles.length; i++) {
    searchToggles[i].addEventListener('click', (e) => {
      document.body.classList.toggle('is-open-search');
      document.body.classList.remove('is-open-menu');
      if (document.body.classList.contains('is-open-search')) {
        const searchInput = document.querySelector('.js-search-form-input');
        if (searchInput) {
          searchInput.focus();
        }
      }
    });
  }

  // make the call chainable
  return this;

};

/**
 * Init pages menu
 */
component_pages_menu();

